import CheckCircleIconSvg from '@/assets/svgs/circle-check.svg';
import CircleExclamationOutlineIconSvg from '@/assets/svgs/circle-exclamation-outline.svg';
import CircleInfoIconSvg from '@/assets/svgs/circle-info.svg';
import CircleTimesIconSvg from '@/assets/svgs/circle-times.svg';
import { AlertType } from './types';

export const getAlertIcon = (type: AlertType) => {
  switch (type) {
    case 'error':
      return <CircleTimesIconSvg className="h-6 w-6" />;
    case 'warning':
      return <CircleExclamationOutlineIconSvg className="h-6 w-6" />;
    case 'info':
      return <CircleInfoIconSvg className="h-6 w-6" />;
    case 'success':
      return <CheckCircleIconSvg className="h-6 w-6" />;
  }
};
